<template>
  <div class="villageDetail">
    <div class="titleWrap">
      <div class="setTitle">{{ villageName }}</div>
      <div class="totalCount">
        共 <span class="number">{{ buildingTotal }}</span> 栋楼宇，<span class="number">{{ userTotal }}</span> 个住户，<span class="number">{{ liftTotal }}</span> 台电梯<!-- (年检 <span class="number">{{ checkTotal }}</span> 台，保养 <span class="number">{{ maintainTotal }}</span> 台) -->，一梯一档 <span class="number">{{ oneLiftTotal }}</span> 份
      </div>
      <div class="clearfix"></div>
      <div class="villageCode">
        <div class="codeTitle">小区编码：</div>
        <div class="codeValue">{{ villageCode }}</div>
        <div class="clearfix"></div>
      </div>
      <div class="villageAddress">
        <div class="addressImg"></div>
        <span class="addressName">{{ villageAddress }}</span>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="cardWrap" v-if="villageID === ''">
      <div class="cardHeader">管理员信息</div>
      <div class="cardTitle">用户名：</div>
      <div class="cardValue">{{ username }}</div>
      <div class="cardTitle">联系人：</div>
      <div class="cardValue">{{ personName }}</div>
      <div class="cardTitle">联系方式：</div>
      <div class="cardValue">{{ phone }}</div>
      <el-button class="editBtn" type="text" @click="editManager">编辑</el-button>
      <el-button class="editBtn" type="text" @click="initPassword(userId)">初始化密码</el-button>
    </div>
    <div class="cardWrap">
      <div class="cardHeader">写卡器信息</div>
      <div class="cardTitle">IC卡写卡器终端序列号：</div>
      <div class="cardValue">{{ cardSN }}</div>
      <div class="cardTitle">扇区：</div>
      <div class="cardValue">{{ cardSection }}</div>
      <el-button class="editBtn" type="text" @click="editCard(villageId)">编辑</el-button>
    </div>
    <el-select class="select" v-model="buildingValue" filterable clearable size="small" placeholder="楼宇号" @change="changeBuilding">
      <el-option v-for="item in buildingList" :key="item.id" :label="item.value" :value="item.id"></el-option>
    </el-select>
    <el-main class="tableWrap">
      <el-row class="myRow">
        <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="12" class="mycol" v-for="(item, index) in buildingAttr" :key="index">
          <div class="contentWrap" @click="detail(item.building)">
            <div class="building">{{ item.building }}栋</div>
            <div class="contentModle">
              <div class="contentDiv">
                <div class="contentImg liftImg"></div>
                <div class="contentNumber">{{ item.liftbaseCount }}</div>
                <div class="contentExplain">电梯(台)</div>
              </div>
              <div class="contentDiv">
                <div class="contentImg userImg"></div>
                <div class="contentNumber">{{ item.ownerCount }}</div>
                <div class="contentExplain">住户(人)</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-main>
    <!-- 新增编辑IC卡写卡器弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="终端序列号" prop="cardSN">
          <el-input v-model.trim="form.cardSN" placeholder="终端序列号"></el-input>
        </el-form-item>
        <el-form-item label="扇区" prop="cardSection">
          <el-input v-model.trim="form.cardSection" placeholder="扇区"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增编辑管理员信息弹出层 -->
    <el-dialog :visible.sync="dialogManager" :title="titleManager" width="500px" :close-on-click-modal="false" @close="notBtnManager">
      <el-form ref="formManager" :model="formManager" :rules="rulesManager" label-width="100px" size="small">
        <el-form-item label="用户名" required>
          <el-input v-model.trim="formManager.username" disabled placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="personName">
          <el-input v-model.trim="formManager.personName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model.trim="formManager.phone" placeholder="联系方式"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtnManager">取 消</el-button>
        <el-button size="small" type="primary" :loading="loadingManager" @click="okBtnManager">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'VillageDetail',
  data () {
    return {
      villageID: this.$store.state.user.villageId, // 登录时的小区ID
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageCode: '', // 小区编码
      villageAddress: '', // 小区地址
      buildingValue: '', // 楼宇号下拉菜单选中value
      buildingList: [], // 楼宇号下拉菜单
      buildingTotal: 0, // 楼宇总数
      userTotal: 0, // 住户总数
      liftTotal: 0, // 电梯总数
      checkTotal: 0, // 年检总数
      maintainTotal: 0, // 保养总数
      multimediaTotal: 0, // 多媒体素材总数
      oneLiftTotal: 0, // 一梯一档总数
      cardSN: '', // IC卡写卡器终端序列号
      cardSection: '', // IC卡写卡器扇区
      userId: '', // 用户Id
      username: '', // 用户名
      personName: '', // 管理员姓名
      phone: '', // 管理员联系方式
      buildingAttr: [], // 楼宇列表
      dialog: false, // IC卡写卡器弹出层状态
      title: '', // IC卡写卡器弹出层标题
      loading: false, // IC卡写卡器弹出层确定按钮loading
      form: {
        cardSN: '', // 终端序列号
        cardSection: '' // 扇区
      },
      rules: {
        cardSN: [
          {
            required: true,
            message: '请输入终端序列号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value)) {
                callback(new Error('终端序列号由英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        cardSection: [
          {
            required: true,
            message: '请输入扇区',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value)) {
                callback(new Error('扇区由数字组成'))
              } else {
                if (Number(value) > 16 || Number(value) < 1) {
                  callback(new Error('扇区范围是1~16'))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      dialogManager: false, // 管理员信息弹出层状态
      titleManager: '', // 管理员信息弹出层标题
      loadingManager: false, // 管理员信息弹出层确定按钮loading
      formManager: {
        userId: '', // 用户Id
        username: '', // 用户名
        personName: '', // 联系人
        phone: '' // 联系方式
      },
      rulesManager: {
        personName: [
          {
            required: true,
            message: '请输入联系人',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('联系人由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                callback(new Error('请输入正确的联系方式'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  mounted () {
    // 小区Id
    this.villageId = this.$route.query.id
    // 小区名称
    this.villageName = decodeURI(decodeURI(this.$route.query.villageName))
    // 小区编码
    this.villageCode = this.$route.query.villageCode.substr(0, 3) + ' ' + this.$route.query.villageCode.substr(3, 3) + ' ' + this.$route.query.villageCode.substr(6, 3)
    // 小区地址
    this.villageAddress = decodeURI(decodeURI(this.$route.query.villageAddress))

    // 获取楼宇号下拉框
    this.$http.get(this.$api.building_list, {
      params: {
        orgId: this.villageId
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        for (let i = 0; i < data.data.data.length; i++) {
          this.buildingList.push({
            id: data.data.data[i],
            value: data.data.data[i] + '栋'
          })
        }
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取IC卡写卡器详情
    this.getCardWriter()
    // 获取管理员信息详情
    this.getManagerInfo()

    // 获取楼宇列表
    this.getBuildingList('')
    // 获取小区信息统计
    this.getVillageCount()
  },
  methods: {
    getCardWriter () {
      this.$http.get(this.$api.writer_info, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.cardSN = this.$null(data.data.writer)
          this.cardSection = this.$null(data.data.sector)
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getManagerInfo () {
      this.$http.get(this.$api.village_detail, {
        params: {
          id: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.userId = this.$null(data.data.data.manager.id)
          this.username = this.$null(data.data.data.manager.account)
          this.personName = this.$null(data.data.data.manager.name)
          this.phone = this.$null(data.data.data.manager.phone)
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getBuildingList (buildName) {
      this.$http.get(this.$api.building_info, {
        params: {
          orgId: this.villageId,
          building: buildName
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.buildingAttr = data.data.data
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getVillageCount () {
      this.$http.get(this.$api.org_info, {
        params: {
          id: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.buildingTotal = data.data.data.countBuilding
          this.userTotal = data.data.data.countOwner
          this.liftTotal = data.data.data.countLiftBase
          // this.checkTotal = data.data.data.njNum
          // this.maintainTotal = data.data.data.byNum
          // this.multimediaTotal = data.data.data.mediaNum
          this.oneLiftTotal = data.data.data.countFile
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    changeBuilding (val) {
      this.getBuildingList(val)
    },
    editCard (id) {
      this.$http.get(this.$api.writer_info, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.form.cardSN = data.data.writer
          this.form.cardSection = data.data.sector
          this.title = '编辑IC卡写卡器'
          this.dialog = true
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    editManager () {
      this.$http.get(this.$api.village_detail, {
        params: {
          id: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.formManager.userId = data.data.data.manager.id
          this.formManager.username = data.data.data.manager.account
          this.formManager.personName = data.data.data.manager.name
          this.formManager.phone = data.data.data.manager.phone
          this.titleManager = '编辑管理员'
          this.dialogManager = true
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    initPassword (id) {
      this.$confirm('是否初始化密码为123456?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = new FormData()
        formData.append('id', id)
        formData.append('newPassword', '123456')

        this.$http({
          method: 'post',
          url: this.$api.reset_password,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '密码已初始化为123456',
              type: 'success',
              duration: 1000
            })
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    notBtn () {
      this.loading = false
      this.$refs.form.resetFields()
      this.dialog = false
    },
    notBtnManager () {
      this.loadingManager = false
      this.$refs.formManager.resetFields()
      this.dialogManager = false
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          let formData = new FormData()
          formData.append('id', this.villageId)
          formData.append('writer', this.form.cardSN)
          formData.append('sector', this.form.cardSection)

          this.$http({
            method: 'post',
            url: this.$api.writer_edit,
            data: formData
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.$message({
                message: '编辑IC卡写卡器成功',
                type: 'success',
                duration: 1000
              })
              this.notBtn()
              this.getCardWriter()
              this.loading = false
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
              this.loading = false
            }
          }).catch((err) => {
            console.log(err)
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    okBtnManager () {
      this.$refs.formManager.validate((valid) => {
        if (valid) {
          this.loadingManager = true

          let formData = new FormData()
          formData.append('id', this.formManager.userId)
          formData.append('name', this.formManager.personName)
          formData.append('phone', this.formManager.phone)

          this.$http({
            method: 'post',
            url: this.$api.admin_edit,
            data: formData
          }).then((res) => {
            let data = res.data

            if (data.success) {
              this.$message({
                message: '编辑管理员信息成功',
                type: 'success',
                duration: 1000
              })
              this.notBtnManager()
              this.getManagerInfo()
              this.loadingManager = false
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
              this.loadingManager = false
            }
          }).catch((err) => {
            console.log(err)
            this.loadingManager = false
          })
        } else {
          return false
        }
      })
    },
    detail (name) {
      this.$router.push('buildingDetail?buildingName=' + encodeURI(encodeURI(name)) + '&villageId=' + this.villageId + '&villageName=' + encodeURI(encodeURI(this.villageName)) + '&villageAddress=' + encodeURI(encodeURI(this.villageAddress)))
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.villageDetail
  box-sizing border-box
  padding 80px 0 0 20px
  width 100%
  min-height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 86px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .totalCount
      float right
      margin-right 20px
      height 32px
      line-height 32px
      font-size 14px
      color #333
      .number
        color #F02B54
    .villageCode
      margin 8px 0
      height 20px
      line-height 20px
      font-size 14px
      .codeTitle
        float left
        color #666
      .codeValue
        float left
        color #333
    .villageAddress
      margin-top 8px
      line-height 16px
      font-size 12px
      color #666
      .addressImg
        float left
        width 16px
        height 16px
        background-image url('./address_16.png')
        background-repeat no-repeat
        background-size 100% 100%
      .addressName
        float left
        margin-left 8px
  .cardWrap
    box-sizing border-box
    margin-top 16px
    margin-right 20px
    height 50px
    line-height 50px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .cardHeader
      float left
      width 102px
      height 50px
      background-image url('./card_reader_title_bg.png')
      background-repeat no-repeat
      background-size 100% 100%
      font-size 14px
      color #333
      text-align center
      vertical-align middle
    .cardTitle
      float left
      margin-left 24px
      height 50px
      font-size 14px
      color #666
      vertical-align middle
    .cardValue
      float left
      height 50px
      font-size 14px
      color #333
      vertical-align middle
    .editBtn
      float right
      margin-top 16px
      margin-right 20px
      padding 0
      line-height 18px
      border none
  .select
    margin-top 20px
    width 100px
  .tableWrap
    padding 0
    border-radius 4px
    .myRow
      padding-bottom 20px
      overflow hidden
      .mycol
        margin-top 20px
        padding-right 20px
        min-width 270px
        .contentWrap
          box-sizing border-box
          position relative
          padding 20px 20px 0
          width 100%
          height 180px
          background-color #fff
          box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
          border-radius 4px
          cursor pointer
          &:hover
            box-shadow 0 3px 10px 0 rgba(31, 145, 243, .4)
          .building
            margin-bottom 14px
            line-height 20px
            font-size 16px
            color #333
            font-weight bold
          .contentModle
            display flex
            .contentDiv
              flex 1
              .contentImg
                margin 0 auto
                width 56px
                height 56px
                background-repeat no-repeat
                background-size 100% 100%
                &.liftImg
                  background-image url('../../assets/img/lift_color.png')
                &.userImg
                  background-image url('../../assets/img/user_color.png')
              .contentNumber
                line-height 24px
                font-size 20px
                font-weight bold
                color #333
                text-align center
              .contentExplain
                margin-bottom 32px
                line-height 16px
                font-size 12px
                color #666
                text-align center
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
        .el-upload
          width 96px
          height 96px
          line-height 96px
        .el-upload-list__item
          width 96px
          height 96px
        .uploadText
          display block
          height 32px
          margin-top -70px
          font-size 14px
          color #333
        .el-upload__tip
          width 208px
          line-height 22px
          font-size 14px
          color rgba(0, 0, 0, .45)
</style>



// WEBPACK FOOTER //
// src/components/village/villageDetail.vue